import sliceCreator from '../../index.jsx';
import {GET_DAILY_PUNCHES} from '../../../constants/index.jsx';
const _getAllDailyPunchesAction = sliceCreator('GET_ALL_DAILY_PUNCHES', GET_DAILY_PUNCHES, 'get');

const { asyncAction: getAllDailyPunchesAction, reducer, clearData: clearGetAllDailyPunchesAction } = _getAllDailyPunchesAction;

export default reducer;

export {
    getAllDailyPunchesAction,
    clearGetAllDailyPunchesAction
}